// extracted by mini-css-extract-plugin
module.exports = {"lightBoxImage":"GalleryItem_lightBoxImage__AARZD","iframeHolder":"GalleryItem_iframeHolder__mnLHP"};